import { useState } from 'react';
import matchSorter from 'match-sorter';
import get from 'lodash/get';
import { navigate } from 'gatsby';
import qs from 'query-string';

export default function useSearchSortFilter(
  items,
  { initialFilter, initialSearch, initialSort, location, saveQuery, searchFields = [] } = {},
) {
  const [filter, setFilter] = useState(initialFilter || {});
  const [search, setSearch] = useState(initialSearch || '');
  const [sort, setSort] = useState(initialSort || {});

  const handleFilter = (key, value) => {
    const existingValues = filter[key];

    let newValues;
    if (existingValues && existingValues.includes(value)) {
      newValues = existingValues.filter((v) => v !== value);
    } else {
      newValues = [...existingValues, value];
    }

    const newFilter = {
      ...filter,
      [key]: newValues,
    };

    if (saveQuery) {
      navigate(`${location.pathname}?${qs.stringify(newFilter, { arrayFormat: 'bracket' })}`);
    }

    setFilter(newFilter);
  };

  const handleSearch = (search) => {
    setSearch(search);
  };

  const handleSort = (sort) => {
    setSort(sort);
  };

  const filterItems = (data) => {
    if (!filter) return data;

    let filtered = data;

    Object.entries(filter).forEach(([key, selectedValues]) => {
      if (Array.isArray(selectedValues) && selectedValues.length > 0) {
        filtered = filtered.filter((item) => {
          const itemValue = get(item, key);

          if (Array.isArray(itemValue)) {
            return selectedValues.some((val) => itemValue.includes(val));
          }

          return selectedValues.includes(itemValue);
        });
      }

      else if (typeof selectedValues === 'function') {
        filtered = filtered.filter(selectedValues);
      }
    });

    return filtered;
  };

  const sortItems = (data) => {
    if (sort) {
      let order = [1, -1];
      if (sort.order === 'desc') order = [-1, 1];

      return data.sort((a, b) => {
        let aKey = get(a, sort.key);
        let bKey = get(b, sort.key);

        if (sort.parse) {
          aKey = sort.parse(aKey);
          bKey = sort.parse(bKey);
        }

        if (aKey > bKey) return order[0];
        if (aKey < bKey) return order[1];
        return 0;
      });
    }

    return data;
  };

  const searchItems = (data) => {
    if (search) {
      return matchSorter(data, search, {
        keys: searchFields,
        threshold: matchSorter.rankings.WORD_STARTS_WITH,
      });
    }

    return data;
  };

  const getResolvedItems = () => {
    const sorted = sortItems([...items]);
    const filtered = filterItems(sorted);
    const searched = searchItems(filtered);

    return searched;
  };

  const controller = {
    filter: handleFilter,
    search: handleSearch,
    sort: handleSort,
    state: {
      filter,
      search,
      sort,
    },
  };

  return { controller, items: getResolvedItems() };
}
